const ReportGroup = {
    INTAKE: "INTAKE",
    NONE: "NONE",
    ORDERS_VS_BUDGET: "ORDERS_VS_BUDGET",
    PRICE_CHANGES: "PRICE_CHANGES",
    PRICE_MAP: "PRICE_MAP",
    PRODUCT_BY_SUPPLIER: "PRODUCT_BY_SUPPLIER",
    PRODUCTION_STATUS: "PRODUCTION_STATUS",
    SHARE_TO_ORDER_IN_SEASON: "SHARE_TO_ORDER_IN_SEASON",
    SUPPLIER: "SUPPLIER",
}

export default ReportGroup;